if (!customElements.get('ss-card-product')) {
  customElements.define('ss-card-product', class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      clearTimeout(this.resetTimer);
    }

    onClick(e) {
      const addBtn = e.target.closest('[data-ss-add]');
      if (addBtn) { e.preventDefault(); this.add(addBtn); return; }

      const notifyBtn = e.target.closest('[data-ss-notify]');
      if (notifyBtn) { e.preventDefault(); this.notify(notifyBtn); }
    }

    async add(btn) {
      if (btn.dataset.loading) return;
      btn.dataset.loading = 'true';
      clearTimeout(this.resetTimer);

      try {
        await SS.cart.add({ id: Number(btn.dataset.variantId), quantity: 1 });

        delete btn.dataset.loading;
        btn.dataset.added = 'true';
        this.resetTimer = setTimeout(() => delete btn.dataset.added, 1600);

        if (this.dataset.openCart !== 'false') await SS.cart.openDrawer();
      } catch (err) {
        delete btn.dataset.loading;
        console.error('SS — ajout au panier :', err);
        SS.emit('cart:error', { error: err, variantId: btn.dataset.variantId });
      }
    }

    notify(btn) {
      // Hook : à brancher sur la modale de retour en stock du projet.
      SS.emit('notify:open', {
        productId: this.dataset.productId,
        productUrl: this.dataset.productUrl,
        variantId: btn.dataset.variantId,
        variantTitle: btn.dataset.variantTitle
      });
    }
  });
}